export const AUDIENCE_TYPES = [
  { label: "Buyer", value: "BUYER" },
  { label: "Seller", value: "SELLER" },
  { label: "Guest", value: "GUEST" },
  { label: "All", value: "ALL" },
];

export const CTA_DEFAULTS = {
  primary: { textColor: "#ffffff", backgroundColor: "#e76f22" },
  secondary: { textColor: "#18293d", backgroundColor: "#ffffff" },
};

export const MAX_SLIDES = 20;
export const MAX_SLIDE_BUTTONS = 4;

export const makeId = () => globalThis.crypto?.randomUUID?.() || `hero-${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const createSlideButton = (order = 1, overrides = {}) => ({
  id: makeId(),
  _isTemporary: true,
  label: "",
  label_nl: "",
  url: "",
  textColor: "#FFFFFF",
  backgroundColor: "#000000",
  borderColor: "#000000",
  style: "FILLED",
  openInNewTab: false,
  order,
  ...overrides,
});

export const createEmptySlide = (order = 1) => ({
  id: makeId(), title: "", title_nl: "", subtitle: "", subtitle_nl: "", audienceType: "BUYER",
  buttons: [createSlideButton(1)],
  desktopImage: "", tabletImage: "", mobileImage: "", contentPosition: "start",
  desktopLayout: "start", tabletLayout: "start", mobileLayout: "start",
  desktopVerticalLayout: "center", tabletVerticalLayout: "center", mobileVerticalLayout: "center",
  order, isActive: true, is_permanent: false, startDateTime: null, endDateTime: null,
});

export const createFallbackSlide = (order = 1) => ({
  ...createEmptySlide(order),
  id: "homepage-hero-fallback",
  isFallback: true,
  isActive: true,
  is_permanent: true,
  audienceType: "ALL",
  title: "<p>Where unsold retail inventory finds new value.</p>",
  title_nl: "<p>Waar onverkochte voorraad nieuwe waarde vindt.</p>",
  subtitle: "<p>Shop new items daily from connected stores. Join the monthly Final Sale.</p>",
  subtitle_nl: "<p>Ontdek dagelijks nieuwe items van aangesloten winkels. Doe mee aan de maandelijkse Final Sale.</p>",
  buttons: [createSlideButton(1, {
    label: "Explore Final Sale",
    label_nl: "Ontdek Final Sale",
    url: "/final-sale",
    backgroundColor: "#f26922",
    borderColor: "#f26922",
  })],
});
